import { profiles } from "@shared/api/services"
import { useMutation, useQueryClient } from "@tanstack/react-query"
import { toast } from "react-toastify"
import { reachGoal } from "@utils/lib/yandexMetrika"

// Создание детского профиля. Поля: name, bday (Y-m-d), instruments (ids), timezone (необязательно — наследуется).
export const useCreateProfile = () => {
	const queryClient = useQueryClient()

	const mutation = useMutation({
		mutationFn: (data) => profiles.create(data),
		onSuccess: () => {
			queryClient.invalidateQueries(['family-profiles'])
			toast.success('Профиль создан')
			reachGoal('create-child-profile')
		},
	})

	return mutation
}
